export const env = {
    apiUrl: 'https://devadminapi.powerhub.pl'
}